import React, { useEffect, useRef, useState } from "react";

import styles from "styles.module.css";

import Filter from "./Filter";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";

import { addMonths } from "date-fns";
import OverLayLoading from "ui/Loading";
import { useTranslation } from "react-i18next";

import { Loading } from "ui/Loading";
import { usePageAccess } from "hooks/usePageAccess";
import { landingNoteJournalGridColumns } from "./GridColumns";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
import {
	getLandingNoteJournalApi,
	LandingNoteJournalFilter,
} from "api/landingNoteoJournal";
import { PageTypePath } from "utils/pages";

const pageSize = 60;

const LandingNoteJournal = () => {
	const { t } = useTranslation();

	const overlayRef = useRef<HTMLDivElement>(null);

	const gridRef = useRef<HTMLDivElement>(null);
	const [filterOptions, setFilterOptions] = useState<LandingNoteJournalFilter>({
		fromDate: addMonths(new Date(), -1),
		toDate: new Date(),
	});

	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);

	const { pageAccess, loading } = usePageAccess();

	const exportGridAsPDF = () => {
		localStorage.setItem(
			"fromDate",
			filterOptions.fromDate instanceof Date
				? filterOptions.fromDate.toISOString()
				: "",
		);
		localStorage.setItem(
			"toDate",
			filterOptions.toDate instanceof Date
				? filterOptions.toDate.toISOString()
				: "",
		);
		localStorage.setItem(
			"receiverReceivingFacility",
			filterOptions.receiverReceivingFacility ?? "",
		);
		localStorage.setItem("species", filterOptions.specie ?? "");
		localStorage.setItem("fishingGearCode", filterOptions.fishingGearCode ?? "");
		localStorage.setItem("catchField1", filterOptions.catchField1 ?? "");
		localStorage.setItem("catchField2", filterOptions.catchField2 ?? "");
		localStorage.setItem("conditionCode", filterOptions.conditionCode ?? "");
		localStorage.setItem("preservationCode", filterOptions.preservationCode ?? "");
		localStorage.setItem(
			"fishermanLedgerAccount",
			filterOptions.fishermanLedgerAccount ?? "",
		);

		window.open(`/${PageTypePath.Pdf}/0/9/`, "_blank");
	};

	const exportGridAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};

	if (!pageAccess) {
		return <Loading show={true} />;
	}

	return (
		<div className={styles.PageContainer}>
			<div ref={overlayRef} style={{ display: "none" }}>
				<OverLayLoading />
			</div>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>
					{t("LandingNoteJournal")}
				</legend>
			</div>

			<div>
				<Filter
					setFilterOptions={setFilterOptions}
					filterOptions={filterOptions}
					exportAsPDF={exportGridAsPDF}
					exportAsExcel={exportGridAsExcel}
					pageSize={pageSize}
				/>
			</div>
			<div style={{}} ref={gridRef}>
				<div style={{ marginTop: 30 }} ref={gridRef}>
					<GridWithGroupPaging
						apiMethod={getLandingNoteJournalApi}
						gridColumns={landingNoteJournalGridColumns()}
						pageable={false}
						group={[
							{
								field: "receiverName",
								aggregates: [
									{
										field: "netLiveWeightKg",
										aggregate: "sum",
									},
								],
							},
						]}
						aggregateFields={[
							{
								field: "netLiveWeightKg",
								aggregate: "sum",
							},
						]}
						groupable={{ footer: "visible", enabled: false }}
						filter={filterOptions}
						exportGridAsExcelRef={excelRef}
					/>
				</div>
			</div>
		</div>
	);
};

export default LandingNoteJournal;
